import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import Link from 'next/link';
import Image from 'next/image';
export var PhotoGridItem = function PhotoGridItem(_ref) {
  var href = _ref.href,
      width = _ref.width,
      height = _ref.height,
      src = _ref.src,
      alt = _ref.alt,
      label = _ref.label;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Link, {
      href: href,
      children: /*#__PURE__*/_jsxs("a", {
        className: "jsx-3143747800" + " " + 'item',
        children: [/*#__PURE__*/_jsx("div", {
          className: "jsx-3143747800" + " " + 'photo',
          children: /*#__PURE__*/_jsx(Image, {
            width: width,
            height: height,
            src: src,
            alt: alt
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "jsx-3143747800" + " " + 'label',
          children: label
        })]
      })
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "3143747800",
      children: [".item.jsx-3143747800{display:block;-webkit-text-decoration:none;text-decoration:none;text-align:center;color:#151824;font-weight:700;min-width:0;}", ".photo.jsx-3143747800{width:100%;border:1px solid #CCD0E0;margin-bottom:10px;-webkit-transition:all 200ms ease;-webkit-transition:all 200ms ease;transition:all 200ms ease;position:relative;top:0;}", ".item.jsx-3143747800:hover .photo.jsx-3143747800{border-color:#65A0F4;-webkit-box-shadow:0 10px 13px 0 rgba(0,0,0,0.2);box-shadow:0 10px 13px 0 rgba(0,0,0,0.2);top:-3px;}"]
    })]
  });
};
export var PhotoGrid = function PhotoGrid(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "jsx-2403597064" + " " + 'photo-grid',
      children: children
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "2403597064",
      children: [".photo-grid.jsx-2403597064{display:grid;grid-gap:38px;grid-template-columns:repeat(3,1fr);}", "@media(max-width:504px){.photo-grid.jsx-2403597064{grid-template-columns:repeat(2,1fr);}}", "@media(min-width:768px){.photo-grid.jsx-2403597064{grid-template-columns:repeat(4,1fr);}}", "@media(min-width:992px){.photo-grid.jsx-2403597064{grid-template-columns:repeat(5,1fr);}}", "@media(min-width:1200px){.photo-grid.jsx-2403597064{grid-template-columns:repeat(6,1fr);}}"]
    })]
  });
};